import template from "./pCountries.html";
import featureFlags from "theme/utils/featureFlags.js";

export function pCountriesDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCountriesController,
    controllerAs: 'pCountries',
    bindToController: true
  };

  return directive;
}

const seniorityLevels = [
  {
    name: "L01",
    editionDisabled: true
  },
  {
    name: "L02",
    editionDisabled: true
  },
  {
    name: "L03"
  },
  {
    name: "L04",
    editionDisabled: true
  },
  {
    name: "L05"
  },
  {
    name: "L06",
    editionDisabled: true
  },
  {
    name: "L07"
  },
  {
    name: "L08",
    editionDisabled: true
  },
  {
    name: "L09"
  },
  {
    name: "L10",
    editionDisabled: true
  }
];

class pCountriesController {
  constructor(Auth, Admin, $location, Notes, $scope, $interval, ConnectionQuality) {
    'ngInject';
    this.Auth = Auth;
    this.Admin = Admin;
    this.$location = $location;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.$scope = $scope;
    this.$interval = $interval;

    this.init();

    this.featureFlags = featureFlags;

    this.sideBarConfig = {};

    this.actions = [];

    this.rowActions = [
      {
        name: "view",
        functionName: "viewCountry"
      }
    ];

    this.fields = {
      name: "info",
      code: "info",
      currency: "number"
    };

    /*
    * b-dialog-card data
    */

    this.newCountryData = {
      name: {
        type: "text"
      },
      code: {
        type: "text",
        maxlength: 2,
        onkeydown: "return /[a-zA-Z]/i.test(event.key)",
        tooltip: true
      },
      currency: {
        type: "text",
        tooltip: true
      }
    };

    this.featureFlags.forEach(flag => {
      if (flag === "PartTimeVacation") {
        this.newCountryData[flag] = {
          type: "checkbox_reliant",
          reliantOn: "VacationReporting",
          isNotRequired: true
        };
      } else if (flag === 'ClientMdpIdRequired') {
        this.newCountryData[flag] = {
          type: "checkbox_reliant",
            reliantOn: "ClientMdpIdAvailable",
            isNotRequired: true
        };
      } else {
        this.newCountryData[flag] = {
          type: "checkbox",
          isNotRequired: true
        };
      }
    });

    this.newCountryData['levels'] = {};

    seniorityLevels.forEach(level => {
      this.newCountryData[level.name] = {
        type: "checkbox",
        editionDisabled: level.editionDisabled,
        isNotRequired: !level.editionDisabled
      };
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection'&& note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {

        this.user = user;
        if (!this.user.isAdmin) {
          if (!this.user.isLocalAdmin)
            this.Auth.handleUnauthorized();
        }
        this.Admin.getCountries().then(
          (success) => {
            this.countries = success.data.length == undefined ? [success.data] : success.data;

            if(this.user.isAdmin) {
              this.actions = [
                {
                  name: "new",
                  functionName: "startAddingNewCountry",
                  fa: "fa-plus"
                }
              ];
            }

            localStorage.setItem("roedl-admin-countries", angular.toJson(this.countries));

            this.sideBarConfig = {
              "countries": success.data.length == undefined ? [success.data] : success.data
            };

            var timeout = this.$interval(() => {
              this.notes = this.Notes.getNotes();
            }, 10);
            this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});

            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  viewCountry(country) {
    this.$location.path(`/admin/countries/${country.name}`);
  }

  startAddingNewCountry() {
    this.newCountryValues = {};
    seniorityLevels.forEach(level => {
      if (level.editionDisabled)
        this.newCountryValues[level.name] = true;
    });
    this.newCountryProcess = true;
  }

  addCountry(country) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    var flags = [];

    this.featureFlags.forEach(flag => {
      if (flag === "Projects") {
        const flagToSend = "ProjectsSetManually";
        country[flag] == true && flags.push(flagToSend);
      } else if (flag === "OvertimeRequest" && country[flag]) {
        flags.push("OvertimeApplications");
      } else country[flag] == true && flags.push(flag);
    });

    const levels = [];
    seniorityLevels.forEach(level => {
      if (country[level.name]) {
        levels.push(level.name);
        delete country[level.name];
      }
    });

    var newCountry = {
      ...country,
      "flags": flags,
      "seniorityLevels": levels
    };

    this.Admin.addCountry(newCountry).then(
      () => {
        this.init();
        this.newCountryProcess = false;
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  formInvalid(values) {
    const currencyPattern = /^[A-Z]{3}$/;
    const codePattern = /^[A-Z]{2}$/;
    
    if (!values) return true;

    if (
      values.name
      && values.name.length > 0
      && values.code
      && codePattern.test(values.code)
      && values.currency
      && currencyPattern.test(values.currency)
    )
      return false;
    
    return true;
  }
}
